import { User } from "@telarya/telarya-sdk"

import { createSimpleStoreFactory } from "@/components/Other/createSimpleStoreFactory"

export const useCompanyDriversStore = createSimpleStoreFactory(
  "CompanyDrivers",
  (sdkService) => sdkService.getDriversForTenant(), // Fetch function
  User,
  { refreshOnRealtime: true }
)
